export { default } from './card';
export { default as cardConfig } from './card.config';
